(function () {
    'use strict';

    const module = angular.module('uwAgenda.global');
    module.factory('CorrelationService', CorrelationService);

    /* load basic administrative components */
    function CorrelationService() {

        let correlationId = null;
        return {
            generateCorrelationId: generateCorrelationId,
            getCorrelationId: getCorrelationId
        };

        // generate a random correlationId in UUIDV4 format
        function generateCorrelationId() {
            correlationId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
            return correlationId;
        }
        
        // get the current correlationId
        function getCorrelationId() {
            return correlationId;       
        }

    }
})();